import styles from './SummaryItem.module.css';
import { SummaryItemProps } from './types';

const SummaryItem = ({ id, isVisible, title, price }: SummaryItemProps) =>
  isVisible && title && price ? (
    <div id={id} className={styles.summaryPrice}>
      {typeof title === 'string' ? <p className={styles.summaryItemTitle}>{title}</p> : title}
      <p id={`${id}-price`} className={styles.summaryItemPrice}>{price}</p>
    </div>
  ) : null;

export default SummaryItem;
